viewRecord();

function fetchProductByHandle(handle) {
  return fetch(`/products/${handle}.js`)
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        console.log("=====Failed to fetch product=====");
      }
    })
    .catch((error) => {
      console.log(error, "=====error=====");
    });
}

function viewRecord() {
    const recordlistPage = document.getElementById("record-page");
  
    fetch(
      `${heychic_api}/web/product/viewHistory?search_client_id=${localStorage.getItem("clientId")}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Shop-Id": shopIdAuth,
        },
      }
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data.code == 200) {
          var recordlistItems = data.data;
          if (recordlistItems.data.length === 0) {
            recordlistPage.classList.remove("has-halo-block-loader");
            document.getElementById("recordlist-container").innerHTML = `
                              <div class="empty-wishlist-message">
                              <p>Your view record is currently empty.</p>
                              </div>
                          `;
            return;
          }
          
          // 更改数组结构
          const groupedItems = recordlistItems.data.reduce((acc, item) => {
            if (!acc[item.last_view_day_str]) {
              acc[item.last_view_day_str] = [];
            }
            acc[item.last_view_day_str].push(item);
            return acc;
          }, {});

        //   groupedItems={
        //     "2024-09-20": [...],
        //     "2024-09-19": [...],
        //   }
          
  
          Promise.all(
            Object.entries(groupedItems).flatMap(([date, items]) =>//扁平化数组
              Promise.all(
                items.map((item) => fetchProductByHandle(item.product_handle))
              ).then((products) => {
                products = products.filter((item) => Boolean(item));
                return products.map((product, index) => {
                  const itemClass = (index % 2 === 0) ? 'even' : 'odd'; // 分别奇偶样式
                  return `<div class="wishlist-item recordlist-item ${itemClass} variants-num${product.variants.length} ${!product.available
                              ? "sold-out-product"
                              : product.compare_at_price > product.price
                              ? "sale-product"
                              : ""
                          }" id="wishlist-item-${index}">
                              <a href="${product.url}" class="wishlist-img">
                                  <img src="${product.images[0]}" alt="${product.title}">
                              </a>
                              <div class="wishlist-tag sold-out-tag">SOLD OUT</div>
                              <div class="wishlist-tag sale-tag">SALE</div>
                              <div class="wishlist-title-box">
                                  <a href="${product.url}">${product.title}</a>
                              </div>
                                  <p class="wishlist-price">
                                  <span class="original-price">${window.Shopify.currency.active} ${product.price / 100}</span>
                                  <span class="sale-price">${window.Shopify.currency.active} ${product.compare_at_price / 100}</span>
                                  </p>
                          </div>`;
                }).join("");
              }).then((html) => `<h2 style="font-size:1.6rem">${date}</h2>${html}`)//每一块html头部添加日期
            )
          )
          .then((recordlistHTML) => {
            recordlistPage.classList.remove("has-halo-block-loader");
            document.getElementById("recordlist-container").innerHTML = recordlistHTML.join("");
          })
          .catch((error) => {
            recordlistPage.classList.remove("has-halo-block-loader");
            console.error("Error fetching wishlist products:", error);
          });
        }else{
          recordlistPage.classList.remove("has-halo-block-loader");
            document.getElementById("recordlist-container").innerHTML = `
                <div class="empty-wishlist-message">
                <p>Your view record is currently empty.</p>
                </div>
            `;
        }
      })
      .catch((error) => console.error(error));
  }
  
